import _ from "underscore"
import TemplateView from "../../../TemplateView"
import SortableTableHeader from "../../../controls/SortableTableHeader"
import LoadingMoire from "../../../LoadingMoire"
import ReportedTimeRow from "./ReportedTimeRow"
import Totals from "./Totals";
import {ReportedTimeSortConstants} from '../constants'

export default class ReportedTime extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
    }

    templateHtml() {
        return "<div class='reportedTimeTab panelTab'>" +
               " <div class='summarySection section'/>" +
               " <div class='reportedTimeSection section'>" +
               "     <div class='reportedTimeHeader sectionHeader'><%=reportedTimeComments%>:</div>" +
               "     <table class='reportedTimeTable' cellpadding='0' cellspacing='0'><thead>" +
               "         <tr><th class='dateColumn'><span class='dateCell dateHeader'/></th>" +
               "         <th class='userColumn'><span class='shortSeparator'>&nbsp;</span><span class='userCell userHeader'/></th>" +
               "         <th class='timeColumn'><span class='shortSeparator'>&nbsp;</span><span class='timeCell timeHeader'><%=time%></span></th>" +
               "         <th class='commentColumn'><span class='shortSeparator'>&nbsp;</span><span class='commentCell commentHeader'><%=comment%></span></th></th>" +
               "     </thead><tbody class='timeRows'/></table>" +
               "     <div class='tasksNotFoundMessage'><%-noTimeComments%></div>" +
               "     <div class='loadingIndicatorContainer'></div>" +
               " </div>" +
               "</div>";
    }

    shouldUpdateOnInit() {
        return false;
    }

    messageKeys() {
        return {
            time: 'common.time',
            comment: 'common.comment',
            of: 'common.of',
            reportedTimeComments: 'task.edit_panel.reported_time',
            noTimeComments: 'task.edit_popup.no_time_reported_by_you_for_task'
        }
    }

    afterRender() {
        this.timeRows = {};
        this.timeRowsCount = 0;
        this.$timeRows = this.find('.timeRows');

        this.totals = new Totals(this.find(".summarySection"), {chartContainerId: "reportedTimeChart"}).init();
        this.dateHeader = new SortableTableHeader(this.find('.dateHeader'),
            this.sortBy === ReportedTimeSortConstants.BY_DATE,
            this.sortOrder === ReportedTimeSortConstants.ASC, 'common.date').init()
        this.dateHeader.sortBy = ReportedTimeSortConstants.BY_DATE
        this.userHeader = new SortableTableHeader(this.find('.userHeader'),
            this.sortBy === ReportedTimeSortConstants.BY_USER,
            this.sortOrder === ReportedTimeSortConstants.ASC, 'common.User').init()
        this.userHeader.sortBy = ReportedTimeSortConstants.BY_USER
        this.$loadingIndicatorContainer = this.find(".loadingIndicatorContainer");

        this.appendLoadingMoire = new LoadingMoire({
            additionalSpinnerSettings: {},
            showAnimated: false,
            hideAnimated: false,
        }).init(this.find(this.$loadingIndicatorContainer))
    }

    setTableSettings(settings) {
        this.sortBy = settings['sortBy'];
        this.sortOrder = settings['sortOrder'];
        this.dateHeader.setActive(this.sortBy === ReportedTimeSortConstants.BY_DATE)
        this.userHeader.setActive(this.sortBy === ReportedTimeSortConstants.BY_USER)
        if (this.dateHeader.isActive())
            this.dateHeader.setAsc(this.sortOrder === ReportedTimeSortConstants.ASC)
        if (this.userHeader.isActive())
            this.userHeader.setAsc(this.sortOrder === ReportedTimeSortConstants.ASC)

    }

    updateTimeRows(timeRows) {
        if (timeRows.length === 0) {
            this.find('.tasksNotFoundMessage').show();
        }
        this.addTimeRows(timeRows);
    }

    updateEstimated(estimatedTime) {
        this.totals.header.setState({estimatedTime});
    }

    updateSummaryRecords(executorsSummary = {}) {
        this.totals.setState({
            sorted: false,
            totalTime: executorsSummary.total,
            myRecord: executorsSummary.myRecord,
            myTeamRecords: executorsSummary.myTeamRecords,
            othersRecords: executorsSummary.othersRecords,
            myTeamTotal: executorsSummary.myTeamTotal,
            othersTotal: executorsSummary.othersTotal,
        })
    }

    addTimeRows(timeRows) {
        var self = this;
        _.forEach(timeRows, function(rowData) {
            var newRow = new ReportedTimeRow(self.$timeRows).init();
            newRow.setRowData(rowData.eventDate.parseJSONDate(), rowData.formattedName, rowData.actuals, (rowData.commentsPresent) ? rowData.comments : null);
            self.timeRows[self.timeRowsCount++] = newRow;
        });
    }

    clearTimeRows() {
        this.$timeRows.empty();
        this.find('.tasksNotFoundMessage').hide();
        this.timeRowsCount = 0;
        this.timeRows = {};
    }

    setTimeAndCommentsLoading(isLoading) {
        this.$loadingIndicatorContainer.toggle(isLoading);
        this.appendLoadingMoire.toggle(isLoading)
    }
}



// WEBPACK FOOTER //
// ./web/js/panels/task/reportedTime/ReportedTime.js